/**
 * Schemas to validate the auth payloads
 *
 */

import { DMS_REFERENCE_PATTERN } from 'lib/assets/dms_reference';

// "Notas del vale de resguardo": same limit as the back (assets_schemas.js).
export const CUSTODY_NOTES_MAX_LENGTH = 2000;

const catalogElementSchema = {
  type: 'object',
  properties: {
    id: { type: 'string', pattern: '^[0-9a-fA-F]{24}$' },
    key: { type: 'string' },
    value: { type: 'string' },
    active: { type: 'boolean' },
    editable: { type: 'boolean' },
    deleted: { type: 'boolean' },
  },
  required: ['id', 'key', 'value'],
};

const accountSchema = {
  type: 'object',
  properties: {
    id: { type: 'string', pattern: '^[0-9a-fA-F]{24}$' },
    key: { type: 'string' },
    name: { type: 'string' },
    description: { type: 'string' },
    lifeTime: { type: 'number' },
    depreciationMethod: { type: 'string' },
    childs: { type: 'array' },
    active: { type: 'boolean' },
    deleted: { type: 'boolean' },
  },
  required: ['id', 'key', 'name'],
};

const costCenterSchema = {
  type: 'object',
  properties: {
    id: { type: 'string', pattern: '^[0-9a-fA-F]{24}$' },
    key: { type: 'string' },
    name: { type: 'string' },
    active: { type: 'boolean' },
    deleted: { type: 'boolean' },
  },
  required: ['id', 'key', 'name'],
};

const employeeSchema = {
  type: 'object',
  properties: {
    id: { type: 'string', pattern: '^[0-9a-fA-F]{24}$' },
    key: { type: 'string' },
    name: { type: 'string' },
    position: { type: 'string' },
    active: { type: 'boolean' },
    deleted: { type: 'boolean' },
  },
  required: ['id', 'key', 'name', 'position'],
};

const projectSchema = {
  type: 'object',
  properties: {
    id: { type: 'string', pattern: '^[0-9a-fA-F]{24}$' },
    key: { type: 'string' },
    name: { type: 'string' },
    amount: { type: 'number' },
    active: { type: 'boolean' },
    deleted: { type: 'boolean' },
  },
  required: ['id', 'key', 'name', 'amount'],
};

const providerSchema = {
  type: 'object',
  properties: {
    id: { type: 'string', pattern: '^[0-9a-fA-F]{24}$' },
    key: { type: 'string' },
    name: { type: 'string' },
    mail: { type: 'string' },
    telephone: { type: 'string' },
    rfc: { type: 'string' },
    active: { type: 'boolean' },
    deleted: { type: 'boolean' },
  },
  required: ['id', 'key', 'name'],
};

// const depreciationSchema = {
//   type: "object",
//   properties: {
//     id: { type: "string", pattern: "^[0-9a-fA-F]{24}$" },
//     name: { type: "string" },
//     maximumAmount: {
//       type: "number"
//     },
//     rates: {
//       type: "array",
//       items: {
//         type: "object",
//         properties: {
//           date: {
//             type: "string",
//             minLength: 1
//           },
//           percentages: {
//             type: "array",
//             items: {
//               type: "number"
//             }
//           }
//         },
//         required: ["date", "percentages"]
//       }
//     }
//   }
// };

const schema = {
  add: {
    type: 'object',
    properties: {
      _account: accountSchema,
      _buyCondition: catalogElementSchema,
      _coin: catalogElementSchema,
      _costCenter: costCenterSchema,
      _country: catalogElementSchema,
      _employee: employeeSchema,
      _insuranceCarrier: catalogElementSchema,
      _physicalState: catalogElementSchema,
      _prefix: catalogElementSchema,
      _project: projectSchema,
      _provider: providerSchema,
      _status: catalogElementSchema,
      _subaccount: accountSchema,
      billConcept: { type: ['string', 'null'] },
      billDate: { type: ['string', 'null'], format: 'date-time' },
      billFolio: { type: ['string', 'null'] },
      billNumber: { type: ['string', 'null'] },
      dmsReference: { type: ['string', 'null'], pattern: DMS_REFERENCE_PATTERN },
      custodyNotes: { type: ['string', 'null'], maxLength: CUSTODY_NOTES_MAX_LENGTH },
      customsDocumentsPedimentoNumber: { type: ['string', 'null'] },
      customsDocumentsPedimentoKey: { type: ['string', 'null'] },
      customsDocumentsCustomsKey: { type: ['string', 'null'] },
      customsDocumentsDate: { type: ['string', 'null'], format: 'date-time' },
      customsDocumentsStatus: { type: ['string', 'null'] },
      customsDocumentsImport: { type: ['number', 'null'] },
      customsDocumentsQuantity: { type: ['number', 'null'] },
      brand: { type: ['string', 'null'] },
      buyDate: { type: ['string', 'null'], format: 'date-time' },
      buyOrder: { type: ['string', 'null'] },
      description: { type: ['string', 'null'] },
      insurable: { type: 'boolean' },
      insurancePercent: { type: 'number' },
      insurancePolicy: { type: ['string', 'null'] },
      location: { type: ['string', 'null'] },
      model: { type: ['string', 'null'] },
      name: { type: 'string', minLength: 1 },
      number: { type: 'string', minLength: 1 },
      price: { type: 'number' },
      dollarAssetPrice: { type: ['number', 'null'] },
      exchange: { type: ['number', 'null'] },
      projectPrice: { type: ['number', 'null'] },
      serie: { type: ['string', 'null'] },
      startDate: { type: ['string', 'null'], format: 'date-time' },
    },
    required: ['number', 'name', 'price'],
  },
  disable: {
    type: 'object',
    properties: {
      disableDate: { type: 'string', format: 'date-time' },
      disableDetail: { type: 'string' },
      disableAmount: { type: 'number' },
      _disableReason: catalogElementSchema,
    },
    required: ['_disableReason', 'disableDate', 'disableDetail', 'disableAmount'],
  },
};

export default schema;



// WEBPACK FOOTER //
// src/lib/schemas/assets_schemas.js